
import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { Questions } from "../../classes/question";
import { SecondLanguageService } from "../../shared/services/second-language.service";


@Component({
  selector: 'dep-ques',
  templateUrl: './dep-ques.component.html',
  styleUrls: ['dep-ques.component.css']
})
export class DependentQuestionsComponent implements OnInit {

  @Input() questions: Questions[];
  @Input() parent: number;

  @Output() showSub = new EventEmitter<String[]>();
  @Output() editQuestion = new EventEmitter<Number>();
  @Output() deleteQuestion = new EventEmitter<Number>();
  @Output() addDepFromChild = new EventEmitter<number[]>();

  @Output() move = new EventEmitter<string[]>();

  isSubDragged: boolean = false;
  showSecLangQues:boolean;

  questionTypesList: QuestionTypes[] = [{
    questionType: 'Subjective', displayValue: 'Short Text', icon: '../../assets/images/Short Text.svg'
  }, {
    questionType: 'TextArea', displayValue: 'Long Text', icon: '../../assets/images/Long Text.svg'
  }, {
    questionType: 'WholeNumMax500', displayValue: 'Number', icon: '../../assets/images/Number.svg'
  }, {
    questionType: 'Radio', displayValue: 'Single Choice', icon: '../../assets/images/Radio.svg'
  }, {
    questionType: 'Checkbox', displayValue: 'Multiple Choice', icon: '../../assets/images/Multiple Choice.svg'
  }, {
    questionType: 'Selected Dropdown', displayValue: 'Dropdown', icon: '../../assets/images/Dropdown.svg'
  }, {
    questionType: 'Calendar', displayValue: 'Calendar', icon: '../../assets/images/Calendar.svg'
  }, {
    questionType: 'Map', displayValue: 'Location', icon: '../../assets/images/Location.svg'
  }, {
    questionType: 'Picture Input', displayValue: 'Picture Input', icon: '../../assets/images/Picture Input.svg'
  }, {
    questionType: 'Button', displayValue: 'Cascading Dropdown', icon: '../../assets/images/cascading dropdown.svg'
  },{
    questionType: 'Rating', displayValue: 'Rating', icon: '../../assets/images/star.svg'
  } , {
    questionType: 'Time', displayValue: 'Time', icon: '../../assets/images/time.svg'
  }, {
    questionType: 'Emoji', displayValue: 'Emoji', icon: '../../assets/images/emoji.svg'
  }
  , {
    questionType: 'Range', displayValue: 'Range', icon: '../../assets/images/range.svg'
  }
  , {
      questionType: 'Rank', displayValue: 'Rank', icon: '../../assets/images/rank.svg'
    }
];


  languages: string[];

  constructor(private secondLanguageService: SecondLanguageService) {
    this.languages = this.secondLanguageService.getLanguages();
    this.showSecLangQues =false;
  }

  ngOnInit() {
    if(this.languages[1])
    {
      this.showSecLangQues =true;
    }
    // console.log(this.questions);
  }

  showDepQuestions(i: number) {
    //console.log(i - this.parent - 1);
    //console.log(this.questions[i - this.parent - 1].Qn);
    //TODO: ceck in last if it can be removed as if clean json is formed then the below condition will never occur
    if (!this.questions[i - this.parent - 1].Qn_Deps || this.questions[i - this.parent - 1].Qn_Deps.length <= 0) {
      return;
    }
    //TODO: Remove the first check after creating our own json as it will become unnecessary only for test jsons
    if (this.questions[i - this.parent - 1].Is_Sub_Visible && this.questions[i - this.parent - 1].Is_Sub_Visible === true) {
      //console.log('entered here' + i);
      this.questions[i - this.parent - 1].Is_Sub_Visible = false;
    } else {
      //console.log('I am here');
      this.questions[i - this.parent - 1].Is_Sub_Visible = true;
    }
    //this.showSub.emit([ i.toString() ]);
  }

  // showSubDep(res : string[]){
  //   this.showSub.emit(res);
  // }

  edit(i: number) {
    this.editQuestion.emit(i);
  }

  delete(i: number) {
    this.deleteQuestion.emit(i);
  }

  addDepFromChildEvent(command: number[]) {
    this.addDepFromChild.emit(command);
  }

  sendSubQues(i: number): Questions[] {
    console.log('parent',this.questions[i - this.parent - 1].Qn_Deps);
    if(!this.questions[i - this.parent - 1].Qn_Deps){
      return [];
    }
    let subQues = this.questions.slice(i - this.parent, i + this.questions[i - this.parent - 1].Qn_Deps.length - this.parent);
    return subQues;
  }

  addDepQuestion(type: number, parent: number) {
    
    this.addDepFromChild.emit([type, parent]);
  }

  moveKeyPressInitial(event: any) {
    const pattern = /[0-9\+\-\ ]/;
    let inputChar = String.fromCharCode(event.charCode);

    if (!pattern.test(inputChar)) {
      // invalid character, prevent input
      event.preventDefault();
    }
  }

  moveKeyup(event: any) {

    if (event.target.value.charAt(event.target.value.length - 1) === " ") {
      event.target.value = event.target.value.substring(0, event.target.value.length - 1);
    }
  }


  moveUp(event: any, question_number: number) {
    this.move.emit(["up", event.target.value.toString(), question_number.toString()]);
    //this.moveUpClass = "redBottom";
    //$event.target.parentElement.parentElement.parentElement.parentElement.classList.remove('open');
  }

  moveDown(event: any, question_number: number) {
    this.move.emit(["down", event.target.value.toString(), question_number.toString()]);
    //this.moveDownClass = "redBottom";
  }

  moveToTop(question_number: number) {
    this.move.emit(["toTop", "", question_number.toString()]);
  }

  moveToBottom(question_number: number) {
    this.move.emit(["toBottom", "", question_number.toString()]);
  }

  moveFromChild(str: string[]) {
    this.move.emit(str);
  }

  returnIcon(type: string): string {
    switch (type) {
      case 'Short Text':
        return '../../assets/images/short-ans-icon.svg';
      case 'Long Text':
        return '../../assets/images/long-ans-icon.svg';
      case 'Number':
        return '../../assets/images/num-icon.svg';
      case 'Single Choice':
        return '../../assets/images/single-choice-icon.svg';
      case 'Multiple Choice':
        return '../../assets/images/multiple-choice-icon.svg';
      case 'Dropdown':
        return '../../assets/images/dropdown-icon.svg';
      case 'Calendar':
        return '../../assets/images/calendar-icon.svg';
      case 'Location':
        return '../../assets/images/map-icon.svg';
      case 'Picture Input': 
        return '../../assets/images/picture-icon.svg';
      case 'Cascading Dropdown':
        return '../../assets/images/cascading-dropdown-icon.svg';
      case 'Rating':
        return '../../assets/images/rating-icon.svg';
      case 'Time':
        return '../../assets/images/time-icon.svg';
      case 'Emoji':
        return '../../assets/images/emoji-icon.svg';
      case 'Range':
        return '../../assets/images/range.svg';
      case 'Rank':
        return '../../assets/images/rank-icon.svg';
    }

  }
}

class QuestionTypes {
  questionType: string;
  displayValue: string;
  icon: string;
}



// WEBPACK FOOTER //
// ./src/app/centralPanel/dependenQuestions/dep-ques.component.ts